import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import View from './view';
import PerformanceUtils from 'services/PerformanceUtils';
import { useAppSelector } from 'careand-redux/store';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import { paymentActions } from 'careand-redux/slices/payments';
import { useNavStack, useNavTab } from 'careand-redux/slices/ui/hooks';
import { Stacks, Tabs } from 'careand-redux/slices/ui/navigation';
import AnalyticsContext from 'contexts/AnalyticsContext';
import StripeUtils from 'services/StripeUtils';

const SubscribeScreen = (props) => {
  const { patient, onSuccess } = props;

  const dispatch = useAppDispatch();
  const { trackTagManager } = useContext(AnalyticsContext);

  const patientId = patient.id;

  const masterNav = useNavStack(Stacks.Master);
  const appointmentNav = useNavStack(Stacks.Appointments);
  const { switchTab } = useNavTab();
  const subscription = useAppSelector((state) => state.payments.subscriptions[patient.id]);

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [promoCodeModal, setPromoCodeModal] = useState(false);

  useEffect(() => {
    if (!StripeUtils.isEnabled()) return;
    dispatch(api.Payments.getCreditCards({ patientId }));
    dispatch(api.Payments.getPaymentPlans({ patientId }), { errorTitle: 'Payment Plans' }).then(
      (result) => {
        if (result) {
          onReceivedNewPlans(result, props.hidePayPerUse);
        }
      },
    );
  }, [dispatch, patientId, props.hidePayPerUse]);

  function onReceivedNewPlans(plans, hidePayPerUse) {
    setPlans(processPlans(plans, hidePayPerUse));
  }

  async function onChoosePlan(plan) {
    if (props.onChoosePlan) return props.onChoosePlan(plan);

    if (plan.id === 'unsubscribed') {
      appointmentNav.popTo('/booking');
      switchTab(Tabs.Appointments);
      masterNav.popTo('/', { animation: 'push' });
      return;
    }

    setLoading(true);

    dispatch(paymentActions.saveSubscriptionPlan(plan));

    if (onSuccess) return onSuccess(plan);

    const result = await dispatch(
      api.Payments.createSubscription({ paymentPlanId: plan.id, patientId: patient.id }),
      {
        title: 'Subscription',
        successText: 'You have subscribed successfully!',
      },
    );
    setLoading(false);

    if (result) {
      trackTagManager('subscribe', { value: (plan?.amount || 0) / 100.0 });
      masterNav.pop();
    }
  }

  return (
    <View
      {...props}
      plans={plans}
      loading={loading}
      promoCodeModal={promoCodeModal}
      subscription={subscription}
      onChoosePlan={onChoosePlan}
      openPromoCodeModal={setPromoCodeModal}
      onReceivedNewPlans={onReceivedNewPlans}
    />
  );
};

function processPlans(plans, hidePayPerUse) {
  plans = PerformanceUtils.clone(plans);
  if (hidePayPerUse) plans = plans.filter((plan) => plan.id !== 'unsubscribed');
  return PerformanceUtils.sortBy(plans, [(plan) => plan.amount ?? 0], false);
}

SubscribeScreen.propTypes = {
  patient: PropTypes.object.isRequired,
  onSuccess: PropTypes.func,
};

export default SubscribeScreen;
